import React from 'react';

const NewCloseIcon = ({ size = 16, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    {...props}
  >
    <path
      d="M10.4749 11.1824L4.81808 5.5255C4.6248 5.33223 4.6248 5.01167 4.81808 4.8184C5.01135 4.62512 5.33191 4.62512 5.52518 4.8184L11.182 10.4753C11.3753 10.6685 11.3753 10.9891 11.182 11.1824C10.9888 11.3756 10.6682 11.3756 10.4749 11.1824Z"
      fill="currentColor"
    />
    <path
      d="M4.81796 11.1824C4.62469 10.9891 4.62469 10.6685 4.81796 10.4753L10.4748 4.8184C10.6681 4.62512 10.9886 4.62512 11.1819 4.8184C11.3752 5.01167 11.3752 5.33223 11.1819 5.5255L5.52507 11.1824C5.33179 11.3756 5.01124 11.3756 4.81796 11.1824Z"
      fill="currentColor"
    />
  </svg>
);
export default NewCloseIcon;
